export const DEFAULT_INDENT = "    ";

export function runTabCommand(
  acceptFim: () => boolean,
  indent: () => boolean,
): boolean {
  return acceptFim() || indent();
}
